"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.BackEndErrorCode = exports.CODE_MESSAGE_MAPPING = exports.AddonErrorCode = void 0;
var AddonErrorCode;
(function (AddonErrorCode) {
    AddonErrorCode[AddonErrorCode["SUCCESS"] = 0] = "SUCCESS";
    AddonErrorCode[AddonErrorCode["FUNC_MOUNT_WINDOWS_ERROR"] = 1101] = "FUNC_MOUNT_WINDOWS_ERROR";
    AddonErrorCode[AddonErrorCode["MESSAGE_CONTEXT_ILLEGAL"] = 1201] = "MESSAGE_CONTEXT_ILLEGAL";
    AddonErrorCode[AddonErrorCode["MESSAGE_RESOURCE_ILLEGAL"] = 1301] = "MESSAGE_RESOURCE_ILLEGAL";
    AddonErrorCode[AddonErrorCode["ENVIRONMENT_NETWORK_FAIL"] = 1501] = "ENVIRONMENT_NETWORK_FAIL";
    AddonErrorCode[AddonErrorCode["CALL_DOC_API_ERROR"] = 2101] = "CALL_DOC_API_ERROR";
    AddonErrorCode[AddonErrorCode["IFRAME_NOT_MATCH"] = 2201] = "IFRAME_NOT_MATCH";
    AddonErrorCode[AddonErrorCode["NOT_SINGLE_ADDON_ELEMENT_SELECTED"] = 2202] = "NOT_SINGLE_ADDON_ELEMENT_SELECTED";
    AddonErrorCode[AddonErrorCode["LACK_OF_RANGE_SELECTED"] = 2203] = "LACK_OF_RANGE_SELECTED";
    AddonErrorCode[AddonErrorCode["NO_RANGE_SELECTED"] = 2204] = "NO_RANGE_SELECTED";
    AddonErrorCode[AddonErrorCode["HINA_CONTAINER_NOT_MATCH"] = 2205] = "HINA_CONTAINER_NOT_MATCH";
    AddonErrorCode[AddonErrorCode["IMAGE_NOT_MATCH"] = 2206] = "IMAGE_NOT_MATCH";
    AddonErrorCode[AddonErrorCode["DOC_ARGUMENTS_ILLEGAL"] = 2401] = "DOC_ARGUMENTS_ILLEGAL";
    AddonErrorCode[AddonErrorCode["DOC_ARGUMENTS_TYPE_NOT_MATCH"] = 2402] = "DOC_ARGUMENTS_TYPE_NOT_MATCH";
    AddonErrorCode[AddonErrorCode["DOC_ARGUMENTS_ENUM_NOT_MATCH"] = 2403] = "DOC_ARGUMENTS_ENUM_NOT_MATCH";
    AddonErrorCode[AddonErrorCode["DOC_NETWORK_FAIL"] = 2501] = "DOC_NETWORK_FAIL";
    AddonErrorCode[AddonErrorCode["ADDON_NOT_FOUND"] = 3101] = "ADDON_NOT_FOUND";
    AddonErrorCode[AddonErrorCode["CALL_ADDON_API_ERROR"] = 3102] = "CALL_ADDON_API_ERROR";
    AddonErrorCode[AddonErrorCode["INSERT_ILLEGAL"] = 3201] = "INSERT_ILLEGAL";
    AddonErrorCode[AddonErrorCode["RETURN_VALUE_TYPE_ERROR"] = 3202] = "RETURN_VALUE_TYPE_ERROR";
    AddonErrorCode[AddonErrorCode["IMAGE_IS_OVER_SIZE"] = 3203] = "IMAGE_IS_OVER_SIZE";
    AddonErrorCode[AddonErrorCode["EXTRA_DATA_IS_OVER_SIZE"] = 3204] = "EXTRA_DATA_IS_OVER_SIZE";
    AddonErrorCode[AddonErrorCode["ADDON_NOT_AUTHORIZE"] = 3301] = "ADDON_NOT_AUTHORIZE";
    AddonErrorCode[AddonErrorCode["ADDON_AUTHORIZE_ERROR"] = 3302] = "ADDON_AUTHORIZE_ERROR";
    AddonErrorCode[AddonErrorCode["ADDON_NOT_INSTALLED"] = 3303] = "ADDON_NOT_INSTALLED";
    AddonErrorCode[AddonErrorCode["ADDON_ARGUMENTS_ILLEGAL"] = 3401] = "ADDON_ARGUMENTS_ILLEGAL";
    AddonErrorCode[AddonErrorCode["ADDON_ARGUMENTS_TYPE_NOT_MATCH"] = 3402] = "ADDON_ARGUMENTS_TYPE_NOT_MATCH";
    AddonErrorCode[AddonErrorCode["ADDON_ARGUMENTS_ENUM_NOT_MATCH"] = 3403] = "ADDON_ARGUMENTS_ENUM_NOT_MATCH";
    AddonErrorCode[AddonErrorCode["ADDON_NETWORK_FAIL"] = 3501] = "ADDON_NETWORK_FAIL";
    AddonErrorCode[AddonErrorCode["CALL_FUNC_ERROR"] = 4101] = "CALL_FUNC_ERROR";
    AddonErrorCode[AddonErrorCode["FUNC_NOT_DEFINED"] = 4102] = "FUNC_NOT_DEFINED";
    AddonErrorCode[AddonErrorCode["FUNC_INIT_ERROR"] = 4103] = "FUNC_INIT_ERROR";
    AddonErrorCode[AddonErrorCode["DISPATCH_ERROR"] = 4104] = "DISPATCH_ERROR";
    AddonErrorCode[AddonErrorCode["FUNC_ARGUMENTS_ILLEGAL"] = 4401] = "FUNC_ARGUMENTS_ILLEGAL";
    AddonErrorCode[AddonErrorCode["FUNC_NETWORK_FAIL"] = 4501] = "FUNC_NETWORK_FAIL";
    AddonErrorCode[AddonErrorCode["BACK_INNER_ERROR"] = 5101] = "BACK_INNER_ERROR";
    AddonErrorCode[AddonErrorCode["BACK_NETWORK_FAIL"] = 5501] = "BACK_NETWORK_FAIL";
    AddonErrorCode[AddonErrorCode["STORE_PAY_ERROR"] = 6101] = "STORE_PAY_ERROR";
    AddonErrorCode[AddonErrorCode["STORE_PAY_CANCEL"] = 6102] = "STORE_PAY_CANCEL";
})(AddonErrorCode = exports.AddonErrorCode || (exports.AddonErrorCode = {}));
exports.CODE_MESSAGE_MAPPING = (_a = {},
    _a[AddonErrorCode.SUCCESS] = '成功',
    _a[AddonErrorCode.FUNC_MOUNT_WINDOWS_ERROR] = 'windows挂载异常',
    _a[AddonErrorCode.MESSAGE_CONTEXT_ILLEGAL] = '消息内容不合法',
    _a[AddonErrorCode.MESSAGE_RESOURCE_ILLEGAL] = '消息来源不合法',
    _a[AddonErrorCode.ENVIRONMENT_NETWORK_FAIL] = '网络异常,请稍后重试',
    _a[AddonErrorCode.CALL_DOC_API_ERROR] = '品类侧API调用异常',
    _a[AddonErrorCode.IFRAME_NOT_MATCH] = '选择的iframe匹配不成功',
    _a[AddonErrorCode.NOT_SINGLE_ADDON_ELEMENT_SELECTED] = '选择元素仅需一个且为iframe',
    _a[AddonErrorCode.LACK_OF_RANGE_SELECTED] = '选择元素缺少Range',
    _a[AddonErrorCode.NO_RANGE_SELECTED] = '选择内容为空',
    _a[AddonErrorCode.HINA_CONTAINER_NOT_MATCH] = '选择的插件容器匹配不成功',
    _a[AddonErrorCode.DOC_ARGUMENTS_ILLEGAL] = '品类侧参数不合法',
    _a[AddonErrorCode.DOC_ARGUMENTS_TYPE_NOT_MATCH] = '品类侧参数类型不匹配',
    _a[AddonErrorCode.DOC_ARGUMENTS_ENUM_NOT_MATCH] = '品类侧参数不在枚举值中',
    _a[AddonErrorCode.DOC_NETWORK_FAIL] = '品类侧网络异常,请稍后重试',
    _a[AddonErrorCode.ADDON_NOT_FOUND] = '找不到插件',
    _a[AddonErrorCode.CALL_ADDON_API_ERROR] = '插件API调用异常',
    _a[AddonErrorCode.INSERT_ILLEGAL] = '插入内容不合法',
    _a[AddonErrorCode.RETURN_VALUE_TYPE_ERROR] = '返回值类型错误',
    _a[AddonErrorCode.IMAGE_IS_OVER_SIZE] = '图片大小超过2M',
    _a[AddonErrorCode.EXTRA_DATA_IS_OVER_SIZE] = '插件内容extraData超过了最大字节数限制',
    _a[AddonErrorCode.ADDON_NOT_INSTALLED] = '插件未安装',
    _a[AddonErrorCode.ADDON_NOT_AUTHORIZE] = '插件未授权',
    _a[AddonErrorCode.ADDON_AUTHORIZE_ERROR] = '插件授权异常',
    _a[AddonErrorCode.ADDON_ARGUMENTS_ILLEGAL] = '插件参数不合法',
    _a[AddonErrorCode.ADDON_ARGUMENTS_TYPE_NOT_MATCH] = '插件参数类型不匹配',
    _a[AddonErrorCode.ADDON_ARGUMENTS_ENUM_NOT_MATCH] = '插件参数不在枚举值中',
    _a[AddonErrorCode.ADDON_NETWORK_FAIL] = '插件网络异常,请稍后重试',
    _a[AddonErrorCode.CALL_FUNC_ERROR] = '云函数调用失败',
    _a[AddonErrorCode.FUNC_NOT_DEFINED] = '云函数不存在',
    _a[AddonErrorCode.FUNC_INIT_ERROR] = '云函数初始化异常',
    _a[AddonErrorCode.DISPATCH_ERROR] = '入口函数分发异常',
    _a[AddonErrorCode.FUNC_ARGUMENTS_ILLEGAL] = '云函数参数不合法',
    _a[AddonErrorCode.FUNC_NETWORK_FAIL] = '云函数网络异常,请稍后重试',
    _a[AddonErrorCode.BACK_INNER_ERROR] = '操作异常,请稍后重试',
    _a[AddonErrorCode.BACK_NETWORK_FAIL] = '后台网络异常，请稍后重试',
    _a[AddonErrorCode.STORE_PAY_ERROR] = '支付失败',
    _a[AddonErrorCode.STORE_PAY_CANCEL] = '已取消支付',
    _a);
var BackEndErrorCode;
(function (BackEndErrorCode) {
    BackEndErrorCode[BackEndErrorCode["USER_NOT_LOGIN"] = 10015] = "USER_NOT_LOGIN";
    BackEndErrorCode[BackEndErrorCode["ADDON_QUERY_ERR"] = 54000] = "ADDON_QUERY_ERR";
    BackEndErrorCode[BackEndErrorCode["ADDON_NOT_FOUND"] = 54001] = "ADDON_NOT_FOUND";
    BackEndErrorCode[BackEndErrorCode["ADDON_NOT_AUTHORIZED"] = 54002] = "ADDON_NOT_AUTHORIZED";
    BackEndErrorCode[BackEndErrorCode["INVOKE_PARAM_ERR"] = 54003] = "INVOKE_PARAM_ERR";
    BackEndErrorCode[BackEndErrorCode["INVOKE_ERR"] = 54004] = "INVOKE_ERR";
    BackEndErrorCode[BackEndErrorCode["ADDON_NOT_INSTALLED"] = 54006] = "ADDON_NOT_INSTALLED";
    BackEndErrorCode[BackEndErrorCode["ADDON_EVENT_INVALID"] = 54007] = "ADDON_EVENT_INVALID";
    BackEndErrorCode[BackEndErrorCode["ADDON_HANDLE_EVENT_FAIL"] = 54008] = "ADDON_HANDLE_EVENT_FAIL";
    BackEndErrorCode[BackEndErrorCode["ADDON_NEW_PACKAGE_UPLOADED_ERR"] = 54009] = "ADDON_NEW_PACKAGE_UPLOADED_ERR";
    BackEndErrorCode[BackEndErrorCode["PRODUCE_MESSAGE_ERR"] = 54010] = "PRODUCE_MESSAGE_ERR";
    BackEndErrorCode[BackEndErrorCode["ADDON_PACKAGE_STATUS_INVALID"] = 54011] = "ADDON_PACKAGE_STATUS_INVALID";
    BackEndErrorCode[BackEndErrorCode["ADDON_DEPLOY_UNZIP_ERR"] = 54012] = "ADDON_DEPLOY_UNZIP_ERR";
    BackEndErrorCode[BackEndErrorCode["ADDON_DEPLOY_AUDIT_FAILED"] = 54013] = "ADDON_DEPLOY_AUDIT_FAILED";
    BackEndErrorCode[BackEndErrorCode["SCF_CALL_ERR"] = 55000] = "SCF_CALL_ERR";
    BackEndErrorCode[BackEndErrorCode["SCF_FUNCTION_NOT_FOUND_ERR"] = 55001] = "SCF_FUNCTION_NOT_FOUND_ERR";
    BackEndErrorCode[BackEndErrorCode["SCF_NETWORK_ERR"] = 55002] = "SCF_NETWORK_ERR";
    BackEndErrorCode[BackEndErrorCode["SCF_RESOURCE_LIMIT_EXCEEDED_ERR"] = 55003] = "SCF_RESOURCE_LIMIT_EXCEEDED_ERR";
    BackEndErrorCode[BackEndErrorCode["SCF_RESOURCE_EXISTS_ERR"] = 55004] = "SCF_RESOURCE_EXISTS_ERR";
    BackEndErrorCode[BackEndErrorCode["SCF_SECRET_ID_INVALID_ERR"] = 55005] = "SCF_SECRET_ID_INVALID_ERR";
    BackEndErrorCode[BackEndErrorCode["SCF_LAYER_NOT_EXIST_ERR"] = 55006] = "SCF_LAYER_NOT_EXIST_ERR";
    BackEndErrorCode[BackEndErrorCode["SCF_OPERATE_CONCURRENCY_BUSY_ERR"] = 55007] = "SCF_OPERATE_CONCURRENCY_BUSY_ERR";
    BackEndErrorCode[BackEndErrorCode["SCF_STATUS_NOT_FOUND"] = 55008] = "SCF_STATUS_NOT_FOUND";
})(BackEndErrorCode = exports.BackEndErrorCode || (exports.BackEndErrorCode = {}));
//# sourceMappingURL=error-code.js.map